import _has from 'lodash/has';

// eslint-disable-next-line import/prefer-default-export
export function getSizeAndFlip(rect, props) {
    const size = {
        width: rect ? rect.width : props.style.width,
        height: rect ? rect.height : props.style.height,
    };

    const flipH = _has(props, 'style.flipH') ? props.style.flipH : 0;
    const flipV = _has(props, 'style.flipV') ? props.style.flipV : 0;

    const flip = {
        flipH: rect ? rect.flipH : flipH,
        flipV: rect ? rect.flipV : flipV,
    };
    return { size, flip };
}
